module.exports = __webpack_public_path__ + "static/media/quote-plato-discourage-fr.8fe2529d.png";